import { constructAsync } from '../../../webmodule-common/other/async-constructor';
import { customElement, state } from 'lit/decorators.js';
import { disposeOf } from '../../../webmodule-common/other/dispose';
import { FranchiseePurchaseOrderListView } from '../purchase-orders/views/franchisee-purchase-order-list-view';
import { getInternalId } from '../../../webmodule-common/other/ui/databinding/databinding';
import { html } from 'lit';
import { TabbedPageBase } from './helpers/page-base';
import { userDataStore } from '../common/current-user-data-store';
import { LangAppPurchaseOrdersPage } from '../../../localization/scripts/dealer-franchisee/pages/app-purchase-orders-lang';

@customElement('app-purchase-orders')
export class AppPurchaseOrdersPage extends TabbedPageBase {
  internalId: string = getInternalId();
  @state()
  purchaseOrderListView: FranchiseePurchaseOrderListView | null = null;

  constructor() {
    super();
  }

  protected async setActiveTabByHash() {
    await this.purchaseOrderListView?.setActiveTabByHash();
  }

  private get elementId(): string {
    return `purchase-order-page-${this.internalId}`;
  }

  render() {
    if (!this.loggedIn) return html``;
    return html`
      <div id=${this.elementId} class="page-content">
        <div class="page-container">${this.purchaseOrderListView?.ui}</div>
      </div>
    `;
  }

  meta() {
    return {
      title: () => LangAppPurchaseOrdersPage.purchaseOrderSummaryTitle(),
      description: 'SoftTech dealer CPQ'
    };
  }

  protected createRenderRoot(): HTMLElement | DocumentFragment {
    return this;
  }

  protected async afterUserConnected() {
    this.purchaseOrderListView = this.purchaseOrderListViewFactory();

    await constructAsync(this.purchaseOrderListView);
    await super.afterUserConnected();
  }

  async dispose() {
    await super.dispose();
    await disposeOf(this.purchaseOrderListView);
    this.purchaseOrderListView = null;
  }

  private purchaseOrderListViewFactory(): FranchiseePurchaseOrderListView {
    const listView = new FranchiseePurchaseOrderListView({
      purchaseOrderOwnerId: async () => {
        await userDataStore.loadCoreDetails();
        //this will need to be changed to a franchisee branch that the user belongs to
        if (!userDataStore.defaultBranch) return '';
        return userDataStore.defaultBranch.id;
      }
    });
    return listView;
  }
}
